import React from 'react';
import './nav.css'


export default function MyNav({pokemon}) {
  return (
  <>
      <ul className="nav">
        <h2 className="heading">POKEFINDER</h2>
      </ul>
  </>
  )
}

